/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as ScatterLayerSpec } from '../../../../layer/preset/scatter/scatter';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';
import type { Data } from '../../specProcessor';

export type Spec = BaseSpec;

type ScatterLayerType = StandardChartLayerSpec & ScatterLayerSpec & ILayerTypeSpec;

// 创建散点图数据类型验证器
const validateScatterDataTypes = createDataTypeValidator('scatter', [
  { field: 'x', type: 'number' },
  { field: 'y', type: 'number' },
  { field: 'size', type: 'number', required: false },
  { field: 'color', type: 'string', required: false }
]);

// 创建散点图编码验证器
const validateScatterEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'size', required: false },
  { field: 'color', required: false }
]);

// 额外的检查函数
const additionalScatterChecks = (layer: ScatterLayerType, data: Data) => {
  // 检查数据量是否足够
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];
  if (values.length <= 1) {
    utils.logger.warn(
      'warning',
      `"${layer.type}" layer requires more than 1 data point to be effective`
    );
  }
};

// 创建并导出散点图处理器
export const scatter = createLayerProcessor<ScatterLayerType>(
  'scatter',
  validateScatterEncoding,
  validateScatterDataTypes,
  additionalScatterChecks
);
